// extracted by mini-css-extract-plugin
module.exports = {"container":"Step_container__3cuMK","infoText":"Step_infoText__wbY20","ownershipLabel":"Step_ownershipLabel__16elJ"};